import { useState } from 'react';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { Field } from 'formik';

interface PasswordInputProps {
    name?: string;
    label?: string;
    placeholder?: string;
}

const PasswordInput = ({ name = 'password', label, placeholder }: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => {
        if (showPassword) {
            setShowPassword(!showPassword);
        } else {
            setShowPassword(!showPassword);
        }
    };
    return (
        <Stack width="100%" spacing={1.5}>
            {label ? <Typography>{label}</Typography> : null}
            <Field dataTestId={`${name}-input`} name={[`${name}`]} fullWidth>
                {
                    // eslint-disable-next-line
                    ({ field, form }: any) => (
                        <TextField
                            {...field}
                            id="outlined-error-helper-text"
                            helperText={form.touched[`${name}`] && form.errors[`${name}`]}
                            error={form.errors[`${name}`] && form.touched[`${name}`]}
                            type={showPassword ? 'text' : 'password'}
                            placeholder={placeholder}
                            inputProps={{
                                'data-testid': `login-password-input`,
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    )
                }
            </Field>
        </Stack>
    );
};
export default PasswordInput;
